import {Panel} from "../../../layout/content/detail/Panel";
import style from "../../style/voucherExpirationWindow.module.scss";
import {Trans, useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useState} from "react";
import {PanelWrapper} from "../../../layout/content/detail/PanelWrapper";
import {useTimeConverter} from "../../../hooks/hooks";
import {Label104x46} from "../../../components/Label";
import {useVoucherExpirationGetter} from "./hooks/userVoucherExpirationGetter/useVoucherExpirationGetter";
import {useParams} from "react-router-dom";
import {useVoucherExpirationActions} from "./hooks/userVoucherExpirationGetter/useVoucherExpirationActions";
import {VoucherExpirationPutDTO} from "../../../types/voucher";

export function UserVoucherExpirationWindow() {
    const { t } = useTranslation("voucher");
    const { timeConverter } = useTimeConverter();
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();

    const { getVoucherExpiration, voucherExpiration} = useVoucherExpirationGetter();
    const { updateVoucherExpiration } = useVoucherExpirationActions();
    const { id } = useParams<"id">();

    useEffect(() => {
        getVoucherExpiration(Number(id)).then();
    }, [id, getVoucherExpiration]);
    console.log(endDate)

    useEffect(() => {
        console.log(voucherExpiration)
        if (voucherExpiration?.availableUntil) {
            setEndDate(voucherExpiration.availableUntil)
            setStartDate(voucherExpiration.createdAt)
        }
    }, [voucherExpiration]);

    const Name = useCallback(
        () =>
            <span className={style.name}>
                {voucherExpiration ? `${voucherExpiration.name}(${voucherExpiration.email})` : ""}
            </span>, [voucherExpiration]);

    const VoucherType = useCallback(
        () =>
            <span className={style.name}>
            {voucherExpiration?.voucherType || ""}
        </span>, [voucherExpiration?.voucherType]);

    const onClickIncreaseExpiration = () => {

        if (id === undefined) {
            alert("일시적인 문제가 발생했습니다.\n다시 시도해주세요.");return;
        }
        if (endDate === undefined) {
            alert("유효기간을 추가해주세요.");return;
        }

        if (window.confirm("사용기한을 수정하시겠습니까?")) {
            const dto:VoucherExpirationPutDTO = {
                productVoucherIdx: Number(id),
                availableUntil: endDate
            }
            updateVoucherExpiration(dto).then(
                () => {
                    if (window.opener && !window.opener.closed) {
                        window.opener.postMessage({ message: 'refreshVoucherExpiration' }, '*');
                    }
                    window.close();
                }
            )
        }
    }

    return(
        <PanelWrapper>
            <Panel title={t("expiration.title")} panelClassName={style.panel}>
                <>
                    <p className={style.desc}>
                    <span className={style.otherDesc}>
                        <Trans t={t} i18nKey={"expiration.description"} components={[<Name/>, <VoucherType/>]}/>
                    </span>
                    </p>
                </>

                <div className={style.dateRange}>
                    <Label104x46 text={"사용기한"} ></Label104x46>
                    <div className={style.dateInput}>
                        {/*<label>시작일:</label>*/}
                        <input
                            className={style.inputs}
                            type="date"
                            readOnly={true}
                            value={timeConverter.convertToFilterDateString(
                                startDate ? new Date(startDate): undefined)}
                            onChange={(e) => setEndDate(
                                timeConverter.convertDateToDateTime(e.target.value))}
                        />
                    </div>
                    <div className={style.text}>~</div>
                    <div className={style.dateInput}>
                        {/*<label>종료일:</label>*/}
                        <input
                            className={style.inputs}
                            type="date"
                            min={timeConverter.convertToFilterDateString(
                                startDate ? new Date(new Date(startDate).getTime() + 24 * 60 * 60 * 1000) : undefined)}
                            value={timeConverter.convertToFilterDateString(
                                endDate ? new Date(endDate) : undefined)}
                            onChange={(e) => setEndDate(
                                timeConverter.convertDateToDateTime(e.target.value))}
                        />
                    </div>
                </div>

                <div className={style.buttonArea}>
                    <button onClick={onClickIncreaseExpiration}>{t("expiration.button")}</button>
                </div>
            </Panel>
        </PanelWrapper>
    )
}
